import { PrivateReadHttpError } from "./readJson";

/** Only for read-only fee estimates. Never wrap submission or proof execution. */
export const readPrivateFeeEstimate = async <T>(
  read: () => Promise<T>
): Promise<T> => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await read();
    } catch (error) {
      if (
        !(error instanceof PrivateReadHttpError) ||
        ![502, 503, 504].includes(error.status)
      )
        throw error;
      if (attempt > 0)
        throw new Error(
          "Fees are temporarily unavailable. Please try again shortly."
        );
      // One bounded retry for an upstream gateway hiccup, not render-driven polling.
      await new Promise((resolve) => setTimeout(resolve, 600));
    }
  }
};
